/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SurveyReplacementDataCutRowStatus {
    UNCHANGED = 'unchanged',
    NEW = 'new',
    USER_CHANGE = 'userChange',
    SUGGESTED = 'suggested',
    UNMAPPED = 'unmapped',
    USER_SKIP = 'userSkip',
}
